import { useEffect, useState } from 'react'

enum BreakpointsEnum {
  isXS = '(max-width: 639px)',
  isSM = '(min-width: 640px)',
  isMD = '(min-width: 784px)',
  isLG = '(min-width: 1024px)',
  isXL = '(min-width: 1280px)',
  is2XL = '(min-width: 1536px)',
}

export default function useMediaQuery() {
  const [breakpoints, setBreakpoints] = useState(() => {
    if (typeof window === 'undefined') {
      return {
        isXS: false,
        isSM: false,
        isMD: false,
        isLG: false,
        isXL: false,
        is2XL: false,
      }
    }

    return {
      isXS: window.matchMedia(BreakpointsEnum.isXS).matches,
      isSM: window.matchMedia(BreakpointsEnum.isSM).matches,
      isMD: window.matchMedia(BreakpointsEnum.isMD).matches,
      isLG: window.matchMedia(BreakpointsEnum.isLG).matches,
      isXL: window.matchMedia(BreakpointsEnum.isXL).matches,
      is2XL: window.matchMedia(BreakpointsEnum.is2XL).matches,
    }
  })

  useEffect(() => {
    const listeners = Object.entries(BreakpointsEnum).map(([key, query]) => {
      const mediaQuery = window.matchMedia(query)
      const handler = (e: MediaQueryListEvent) =>
        setBreakpoints(prev => ({ ...prev, [key]: e.matches }))

      setBreakpoints(prev => ({ ...prev, [key]: mediaQuery.matches }))

      mediaQuery.addEventListener('change', handler)
      return { mediaQuery, handler }
    })

    return () =>
      listeners.forEach(({ mediaQuery, handler }) =>
        mediaQuery.removeEventListener('change', handler),
      )
  }, [])

  return { ...breakpoints }
}
